import { useApolloClient, useQuery } from '@apollo/client';
import { EledoAccounting, EledoAccountingData, EledoAccountingInput, EledoAccountingVars,GET_ELEDO_ACCOUNTING } from 'graphql/EledoAccountingQueries';
import { EledoAddress, EledoAddressInput } from 'graphql/EledoProfile';
import { useEffect, useState } from 'react'

const useEledoAccounting = () => {
  const client = useApolloClient();
  
  const [ eledoAccounting, setEledoAccounting] = useState<EledoAccounting>();

  const { loading, error, data } = useQuery<EledoAccountingData, EledoAccountingVars>(GET_ELEDO_ACCOUNTING);
  
  useEffect(() => {
    if (loading || !data){
      return
    }

    const eledoAccount: EledoAccounting = structuredClone(data.accounting)

    setEledoAccounting(eledoAccount)

  }, [data, client, loading])

  return { loading, error, eledoAccounting }
}

export const eledoAccountingInput = (eledoAccount: EledoAccounting | undefined): EledoAccountingInput | undefined => {
  if(eledoAccount === undefined){
    return undefined
  }
  return {
    billTo: eledoAddressInput(eledoAccount.billTo)
  }
}

export const eledoAddressInput = (eledoAddress: EledoAddress | undefined): EledoAddressInput | undefined => {
  if(eledoAddress === undefined){
    return undefined
  }
  return {
    full_name: eledoAddress.full_name,
    address_line_1: eledoAddress.address_line_1,
    address_line_2: eledoAddress.address_line_2,
    admin_area_2: eledoAddress.admin_area_2,
    postal_code: eledoAddress.postal_code,
    country_code: eledoAddress.country_code,
    tax_id: eledoAddress.tax_id
  }
}

export default useEledoAccounting